import React, { Fragment } from "react";
import { Card, Col, Button, Row, Accordion } from 'react-bootstrap';
import '../../../styles/diario.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faEnvelope, faLocationDot, faPhone, faUser } from '@fortawesome/free-solid-svg-icons'

const Secretaria = (props) => {

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><h5>{props.sec.nome} - {props.sec.sigla}</h5></Card.Header>
                    <Card.Body>
                        <Row xs={1}>
                            <Col>
                                <Row xs={2}>
                                    <Col xs={1}>
                                        <FontAwesomeIcon icon={faLocationDot} />
                                    </Col>
                                    <Col xs={11}>
                                        <p> Endereço: <strong>{props.sec.endereco}</strong></p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row xs={1}>
                            <Col>
                                <Row xs={2}>
                                    <Col xs={1}>
                                        <FontAwesomeIcon icon={faClock} />
                                    </Col>
                                    <Col xs={11}>
                                        <p> Horário de Funcionamento: <strong>{props.sec.horarios}</strong></p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row xs={1}>
                            <Col>
                                <Row xs={2}>
                                    <Col xs={1}>
                                        <FontAwesomeIcon icon={faPhone} />
                                    </Col>
                                    <Col xs={11}>
                                        <p> Telefone: <strong>{props.sec.telefone}</strong></p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row xs={1}>
                            <Col>
                                <Row xs={2}>
                                    <Col xs={1}>
                                        <FontAwesomeIcon icon={faUser} />
                                    </Col>
                                    <Col xs={11}>
                                        <p> Secretário(a): <strong>{props.sec.secretario}</strong></p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row xs={1}>
                            <Col>
                                <Row xs={2}>
                                    <Col xs={1}>
                                        <FontAwesomeIcon icon={faEnvelope} />
                                    </Col>
                                    <Col xs={11}>
                                        <p> E-mail: <strong>{props.sec.email}</strong></p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <p> <strong> Competências</strong></p>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>{props.sec.competencias}</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Secretaria;